import { makeStyles } from "@material-ui/core/styles";
import { themeCommon } from "../../../../styles/theme";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "70%",
        marginBottom: '50px',
        marginTop: '90px',
    },
    margin: {
        height: theme.spacing(3),
    },
    rootMuiSlider: {
        height: "20px",

        '& > span:nth-last-child(3)': {
            display: 'none',
        },
    },
    railMuiSlider: {
        top: 'unset !important',
        height: "20px !important",
        borderRadius: "10px",
        background: "#D7D7D7",
    },
    markMuiSlider: {
        bottom: '15px',
        color: '#3A43BA',
        height: "15px",
        top: '50%',
        transform: 'translateY(-50%)',
        '&[data-index="0"]': {
            display: 'none',
        },
        '&:last-child': {
            display: 'none',
        },
        '&:first-child': {
            display: 'none',
        },
    },
    thumbMuiSlider: {
        width: "17px",
        height: "32px !important",
        background: `${themeCommon.lightBlue} !important`,
        borderRadius: "5px",
    },
    thumbMuiSliderDefault: {
        display: 'none',
    },
    markLabelMuiSlider: {
        color: '#2F2F2F',
        marginTop: "40px",
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize12px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize11px,
        },
        [theme.breakpoints.down('sm')]: {
            width: '50px',
            height: '40px',
            whiteSpace: 'normal',
            textAlign: 'center',
            fontSize: themeCommon.fontSize10px,
        },
    },
    markLabelActiveMuiSlider: {
        color: themeCommon.lightBlue,
    },
    markLabelActiveMuiSliderDefault: {
        color: '#2F2F2F',
    },
}), {
    name: 'ProgressBarQuestionHeadContainer',
    index: 1,
});

export default useStyles;
